import React from "react";
import { Modal } from "react-bootstrap";
import "./ConfirmationModal.css";
import { faCircleQuestion } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BlueBorderBtn from "../../common_btn/blueBorderBtn/BlueBorderBtn";
import BlueBtn from "../../common_btn/blueBtn/BlueBtn";

const ConfirmationModal = ({
  show = true,
  onHide,
  title = "Confirmation",
  statusTitle = "Are you sure?",
  message = "Please confirm whether you wish to proceed with this action.",
  // Single button props
  buttonText,
  onButtonClick,
  // Dual button props
  noButtonText,
  yesButtonText,
  onNoButtonClick,
  onYesButtonClick,
  className = "",
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className={`StatusModal ConfirmationModal common_modal ${className}`.trim()}
    >
      {/* Header Section */}
      <Modal.Header closeButton>
        <Modal.Title className="modal-custom-title">{title}</Modal.Title>
      </Modal.Header>

      {/* Body Section */}
      <Modal.Body className="modal-custom-body">
        <div className="confirm-icon" aria-hidden="true">
          <FontAwesomeIcon icon={faCircleQuestion} />
        </div>

        {/* Text Content */}
        <h5 className="status-title">{statusTitle}</h5>
        {/* div (not p): callers pass block content such as dividers */}
        <div className="status-message">{message}</div>

        {/* Action Buttons */}
        <div className="actions_btn_holder">
          {buttonText ? (
            <BlueBtn btnText={buttonText} onClick={onButtonClick || onHide} />
          ) : (
            <>
              {noButtonText && (
                <BlueBorderBtn
                  btnText={noButtonText}
                  onClick={onNoButtonClick || onHide}
                />
              )}
              {yesButtonText && (
                <BlueBtn
                  btnText={yesButtonText}
                  onClick={onYesButtonClick || onHide}
                />
              )}
            </>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ConfirmationModal;
